var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RConceptProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,4 A20,20 0,1 0,24,44 A20,20 0,1 0,24,4",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14 A6,6 0,1 0,24,26 A6,6 0,1 0,24,14",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,36 C14,30.8 18.5,27 24,27 C29.5,27 34,30.8 34,36 L14,36 Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,31.2 A4.2,4.2 0,1 0,30.5,39.6 A4.2,4.2 0,1 0,30.5,31.2",
    fill: "#00D4FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5,32.2 L32.5,38.6 L31,38.6 L31,36.2 L28.7,36.2 L28.7,34.9 L31,34.9 L31,32.2 Z",
    fill: "#2A0D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RConceptProfile);
export default __webpack_public_path__ + "static/media/p4r_concept_profile.514074e8cc858a303a158e0e289e36cb.svg";
export { ForwardRef as ReactComponent };